export default {
    config: {
        // 移动端工具、下载入口及星使服务暂不开放，改为 true 后统一恢复。
        showMobileTools: false,
        url: process.env.BASE_URL,
        urlApi: process.env.API_URL,
        // 本地通过代理访问接口，构建后使用对应环境域名。
        api: process.env.NODE_ENV === 'development' ? '/api' : process.env.BASE_URL
    },
    format: function(timestamp){
        var date = new Date(timestamp);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
}



// WEBPACK FOOTER //
// ./src/util/util.js